<div *ngIf="showForm" class="mt-4 container-fluid my-5 text-center">
    <h3>Sorry, an error occured when processing your registration.</h3>
    <div>Some functionality may currently be unavailable. We apologize for the inconvenience.</div>
    <div>Try refreshing the page, or submitting again at a later time.</div>
</div>
